import baseRequest from 'queries/baseRequest';

export const getDocumentTypes = () => baseRequest({ path: `${process.env.REACT_APP_BASE_URL}/document_types/` });

export const deleteDocument = (documentId) =>
  baseRequest({
    path: `${process.env.REACT_APP_BASE_URL}/documents/${documentId}`,
    options: {
      method: 'DELETE',
    },
  });

export const restoreDocument = (documentId) =>
  baseRequest({
    path: `${process.env.REACT_APP_BASE_URL}/documents/${documentId}/restore`,
    options: {
      method: 'PATCH',
    },
  });
